exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feed-text[data-v-7e569a34]{font-size:11px}.feed-chip[data-v-7e569a34]{padding-top:2px;padding-left:1px;padding-right:1px;font-weight:bolder;font-size:8px;border-radius:4px;border-style:solid;border-width:2px}.white-channel[data-v-7e569a34]{border-color:#fff}.black-channel[data-v-7e569a34]{border-color:#000}", ""]);

// exports
